module.exports = __webpack_public_path__ + "static/media/woman-tablet.42001786.png";